/*
THESIS: Prostor u kadru pokazuje original, pet smjerova i kupivi match prije objašnjenja; odbija generičan SaaS hero.
OWN-WORLD: Ivory fotografsko polje, duboka šumska akcija, glineni registracijski detalj, tanke mjerne linije i papirnati paneli.
STORY: Korisnik vidi preobrazbu, razumije pet varijanti, zatim fotografira vlastiti prostor i uspoređuje proizvode.
FIRST VIEWPORT: Kopija sjedi na mirnom lijevom rezu; veliki before/after prelazi fold; match traka završava kompoziciju.
FORM: “Prostor u kadru”, najjači od tri vizualizirana smjera; desktop staging s fotografijom preko folda.
*/
import { Navigate, Route, Routes } from "react-router-dom";
import { RouteFocus } from "./components/route-focus";
import { DetailPage } from "./pages/detail-page";
import { GeneratingPage } from "./pages/generating-page";
import { LandingPage } from "./pages/landing-page";
import { NewProjectPage } from "./pages/new-project-page";
import { NotFoundPage } from "./pages/not-found-page";
import { ResultsPage } from "./pages/results-page";

export function App() {
  return (
    <>
      <RouteFocus />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/app" element={<Navigate to="/app/new" replace />} />
        <Route path="/app/new" element={<NewProjectPage />} />
        <Route path="/app/projects/:id/generating" element={<GeneratingPage />} />
        <Route path="/app/projects/:id/results" element={<ResultsPage />} />
        <Route path="/app/projects/:id/results/:variantId" element={<DetailPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
